<template>
  <b-container class="mw-100 mt-3 mb-2">
    <b-card>
      <validation-observer v-slot="{ invalid }" ref="form">
        <b-container class="m-0 p-0 mw-100">
          <b-row>
            <b-col cols="12" sm="12" md="6" lg="3" xl="3">
              <validation-provider :name="`${$tc('message.name')} ${$tc('message.tool')} (*)`"
                                   :rules="{ max: 50, required: true }"
                                   v-slot="{ changed, valid, errors }">
                <b-form-group>
                  <label slot="label" class="m-0 p-0">
                    {{ `${$tc('message.name')} ${$tc('message.tool')}` }}
                  </label>

                  <b-input-group>
                    <b-form-input id="input-surname"
                                  autocomplete="off"
                                  v-model="input.toolName"
                                  :placeholder="`${$tc('message.name')} ${$tc('message.tool')}`"
                                  :state="changed ? valid : null">
                    </b-form-input>
                  </b-input-group>

                  <div v-if="changed && !valid" class="my-invalid-feedback"><h6>{{ first(errors) }}</h6></div>
                </b-form-group>
              </validation-provider>
            </b-col>

            <b-col cols="12" sm="12" md="6" lg="3" xl="3">
              <b-form-group :label="`${$tc('message.type', 1)} (*)`"
                            label-for="asset-type">
                <model-list-select id="asset-type"
                                   option-text="text"
                                   option-value="value"
                                   :class="checkData(input.toolTypeSelected).class"
                                   v-model="input.toolTypeSelected"
                                   :placeholder="`${$tc('message.type')} ${$tc('message.tool')}`"
                                   :list="toolTypeOptions">
                </model-list-select>
              </b-form-group>
            </b-col>
            <b-col cols="12" sm="12" md="6" lg="3" xl="3">
              <b-form-group :label="`${$tc('message.tag', 1)} (*)`"
                            label-for="asset-tag">
                <model-list-select id="asset-tag"
                                   option-text="text"
                                   option-value="value"
                                   v-model="input.tagSelected"
                                   :placeholder="`${$tc('message.tag')}`"
                                   :list="tagsOptions">
                </model-list-select>
              </b-form-group>
            </b-col>
          </b-row>

          <b-row class="mt-0">
            <b-col class="mt-3 justify-content-end d-flex">
              <!-- config[crud], create - read - update - delete -->
              <b-button class="b-c-green mr-2" v-on:click="saveAsset(false)"
                        id="save"
                        v-if="assetId ? config.u : config.c"
                        :disabled="checkSaveButton() || invalid">{{$t('message.save')}}
              </b-button>

              <!-- config[crud], create - read - update - delete -->
              <b-button class="b-c-green mr-2" v-on:click="saveAsset(true)"
                        id="save-and-close"
                        v-if="assetId ? config.u : config.c"
                        :disabled="checkSaveButton() || invalid">{{$t('message.saveClose')}}
              </b-button>

              <b-button class="b-c-green" v-on:click="pushBack()"
                        id="close">{{$t('message.close')}}</b-button>
            </b-col>
          </b-row>
        </b-container>
      </validation-observer>
    </b-card>
  </b-container>
</template>

<script>
import { find, first, isNil } from 'lodash'
import Vue from 'vue'

export default {
  name: 'EditAsset',
  created () {
    this.getOptions()
  },
  mounted () {
    this.$root.$on('change-lang', () => {
      this.$nextTick(() => {
        if (this && this.$refs && this.$refs.form) this.$refs.form.validate()
      })
      if (this.$el.isConnected) {
        this.getOptions()
        this.updateLinks()
      }
    })
  },
  data () {
    const config = this.$route.meta.config
    const assetId = this.$route.params.id !== 'new' ? this.$route.params.id : null
    return {
      config,
      assetId,
      first,
      toolTypeOptions: [],
      input: { toolTypeSelected: null, toolName: null, tagSelected: null },
      allTagsOptions: [],
      tagsOptions: [],
      itemChanged: false,
      watcher: null
    }
  },
  methods: {
    clickedLink (link) {
      this.pushBack(link.href)
    },
    checkWatcher () {
      this.$root.$emit('activeLoader', true)
      if (this.watcher) this.watcher()
      this.itemChanged = false
    },
    addWatcher () {
      this.$root.$emit('activeLoader', false)
      this.watcher = this.$watch('input', () => {
        this.itemChanged = true
      }, { deep: true })
    },
    pushBack (obj) {
      const backObj = obj || { name: 'Asset' }
      if (this.itemChanged) {
        this.$root.$emit('go-back-modal', backObj)
      } else {
        this.$router.push(backObj)
      }
    },
    updateLinks () {
      const links = []
      this.links.forEach(link => {
        links.push({ href: link })
      })
      this.$root.$emit('change-links', links)
    },
    checkData (first) {
      const changed = this.itemChanged
      if (first && first.length > 0) {
        return {
          class: 'form-control is-valid',
          state: true
        }
      } else if (changed) {
        return {
          class: 'form-control is-invalid',
          state: false
        }
      }
      return {
        class: 'form-control',
        state: null
      }
    },
    getOptions () {
      const axiosArray = []
      axiosArray.push(this.getEnum('asset_type', 'toolTypeOptions'))
      axiosArray.push(this.getTags())
      return Vue.myAll(axiosArray).then(() => {
        if (this.assetId) {
          Vue.myGet(this, '/assets/' + this.assetId, 'assets').then((asset) => {
            if (asset.length === 1) {
              this.input.toolName = first(asset).name
              this.tagsOptions.push(find(this.allTagsOptions, item => item.text === first(asset).tagCode))
              this.input.tagSelected = find(this.tagsOptions, item => item.text === first(asset).tagCode)
              this.input.toolTypeSelected = find(this.toolTypeOptions, option => option.value === first(asset).type)
            }
            this.addWatcher()
          }).catch(error => {
            Vue.manageErrors(this, error, Vue.getDimetiorHttpCode())
            return false
          })
        } else {
          this.addWatcher()
        }
      }).catch(error => {
        Vue.manageErrors(this, error, Vue.getDimetiorHttpCode())
        return false
      })
    },
    getEnum (path, obj) {
      const options = []
      return Vue.myGet(this, `/enums/${path}`, 'data').then((items) => {
        items.forEach((item) => {
          options.push({
            value: item.id,
            text: item.descr
          })
        })
        if (obj) {
          this[obj] = options
        }
        return options
      }).catch(error => {
        Vue.manageErrors(this, error, Vue.getDimetiorHttpCode())
        return false
      })
    },
    getTags () {
      const options = []
      return Vue.myGet(this, '/tags?assigned=false', 'tags').then((items) => {
        items.forEach((item) => {
          options.push({
            value: item.id,
            text: item.code
          })
        })
        this.tagsOptions = options
        const allOptions = []
        Vue.myGet(this, '/tags', 'tags').then((allItems) => {
          allItems.forEach((item) => {
            allOptions.push({
              value: item.id,
              text: item.code
            })
          })
          this.allTagsOptions = allOptions
          return allOptions
        }).catch(error => {
          Vue.manageErrors(this, error, Vue.getDimetiorHttpCode())
          return false
        })
      }).catch(error => {
        Vue.manageErrors(this, error, Vue.getDimetiorHttpCode())
        return false
      })
    },
    checkSaveButton () {
      const changed = this.itemChanged
      const type = this.input.toolTypeSelected
      const tag = this.input.tagSelected
      return !changed || isNil(type) || isNil(tag)
    },
    saveAsset (pushBack) {
      const body = {
        name: this.input.toolName,
        tagCode: !isNil(find(this.allTagsOptions, option => option.value === this.input.tagSelected)) ? find(this.allTagsOptions, option => option.value === this.input.tagSelected).text : find(this.allTagsOptions, option => option.value === this.input.tagSelected),
        type: !isNil(this.input.toolTypeSelected.value) ? this.input.toolTypeSelected.value : this.input.toolTypeSelected
      }
      var path = '/assets'
      if (!isNil(this.assetId)) {
        path += '/' + this.assetId
      }
      return Vue.putOrPost(this, !isNil(this.assetId), path, body).then((newItem) => {
        Vue.success(this, `${this.$tc('message.asset', 1)} ${this.$t(newItem.data.id ? 'success.putSuccess' : 'success.postSuccess')}`)
        if (pushBack) {
          this.itemChanged = false
          this.pushBack()
        } else {
          this.$router.push({ name: 'RefreshPage', params: { id: newItem.data.id || this.config.data.id, name: 'EditAsset' } })
        }
      }).catch(error => {
        Vue.manageErrors(this, error, Vue.getDimetiorHttpCode())
        return false
      })
    }
  }
}
</script>

<style scoped>

</style>
